import {useLogger} from '#imports';
import {useApis} from '~/composables';

export function useClientOnboarding() {
    const {clientOnboardingApi} = useApis();
    const logger = useLogger();

    async function getBrowseProfilesOnboarding(): Promise<boolean> {
        try {
            return await clientOnboardingApi.getBrowseProfilesOnboarding();
        } catch (e) {
            logger.error("Couldn't get Browse Profiles onboarding", e);
            return false;
        }
    }

    async function acknowledgeBrowseProfilesOnboarding() {
        try {
            await clientOnboardingApi.acknowledgeBrowseProfilesOnboardingRaw();
        } catch (e) {
            logger.error("Couldn't acknowledge Browse Profiles onboarding", e);
        }
    }

    return {
        getBrowseProfilesOnboarding,
        acknowledgeBrowseProfilesOnboarding,
    };
}
